import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { TeamLogoDto } from './logo.model';

@Injectable()
export class LogoService extends BaseService {
  getEndPoint(): string {
    return '/driverwig/api/v1';
  }

  getPrimaryLogoUrl(fleet: string): string {
    return `${this.serviceUrl}/logo/${fleet}/primaryLogo`;
  }

  getTeamLogo(fleet: string): Promise<TeamLogoDto> {
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient
      .get<TeamLogoDto>(this.serviceUrl + `/logo/${fleet}/teamLogo`, requestOptions)
      .toPromise()
      .then((data) => {
        if (data == null) {
          // Default colors
          data = {
            fleet,
            primaryColor: '#b4121b',
            secondaryColor: 'rgba(180, 18, 27, 0.8)',
          } as TeamLogoDto;
        }

        return data;
      });
  }
  getImageUrl(imageName: string): string {
    const timeOfTheCall = new Date().getTime();
    return `${this.serviceUrl}/logo/image?imageName=${imageName}&${timeOfTheCall}`;
  }

  getWatermarkImageUrl(fleet: string): string {
    return `${this.serviceUrl}/logo/${fleet}/watermarkImage`;
  }
}
